<mat-form-field [hidden]="frmGroup.get(this.configData.name)['hidden']" fxFlex="0 0 100%" appearance="outline" [formGroup]="frmGroup" color="accent">
    <mat-label>{{ configData.label }}</mat-label>
    <input matInput autocomplete="off" type="{{configData.type}}" (focusout)="onCommonEventHander('FOCUSOUT')" [formControlName]="configData.name" [placeholder]="configData.placeHolder"
        [required]="configData.required" (change)="checkMaxlengthChar($event.target.value)"   
        [ngClass]="{'uppercase': configData.upperCase}" 
        />
    <mat-spinner matSuffix [diameter]="18" color="accent" style="float: right; margin-left: 8px" *ngIf="isSpinnerShow"></mat-spinner>
<!--     
    <input type="text" class="normal" 
    name="Name" size="20" maxlength="20" 
    style="text-transform:uppercase" />  -->
    <!-- onkeyup="this.value = this.value.toUpperCase()" -->

    <mat-error *ngIf="frmGroup.get(configData.name).errors">
        <mat-error *ngIf="frmGroup.get(configData.name).errors.required">            
            Required
            <!-- {{frmGroup.get(configData.name).errors | json}} -->                       
        </mat-error> 
        <mat-error *ngIf="frmGroup.get(configData.name).errors.maxLength">      
            Exceeding maximum limit by {{frmGroup.get(configData.name).errors.maxLength.exceedsChar}}
            {{ frmGroup.get(configData.name)?.errors?.maxLength.exceedsChar > 1 ? 'characters' : 'character' }}.
        </mat-error>       
        <mat-error *ngIf="frmGroup.get(configData.name).errors.minLength">      
            Required Minimum limit by {{frmGroup.get(configData.name).errors.minLength.requiredChar}} character.
        </mat-error>       
        <mat-error *ngIf="frmGroup.get(configData.name).errors.pattern && validationType === 'NoSpecialCharacter' ">  
            Special character not allowed.
        </mat-error>
      <mat-error
        *ngIf="frmGroup.get(configData.name).errors.min || (frmGroup.get(configData.name).errors.pattern &&  validationType === 'Numeric' )">
        Only whole positive number allowed.
      </mat-error>
      <mat-error
        *ngIf="frmGroup.get(configData.name).errors.min || (frmGroup.get(configData.name).errors.pattern &&  validationType === 'Decimal' )">
        Only positive number allowed.
      </mat-error>
      <mat-error
        *ngIf="(frmGroup.get(configData.name).errors.pattern &&  validationType === 'DecimalWithMaxlength' )">
        Value should be less than 1000 and restricted to two decimals places.
      </mat-error>
	  <mat-error *ngIf="frmGroup.get(configData.name).errors.unAvailable">
            {{frmGroup.get(configData.name).errors.unAvailable.message}}
      </mat-error>
      <mat-error *ngIf="frmGroup.get(configData.name).errors.pattern && validationType === 'Email' ">  
        Invalid E-Mail not allowed.
      </mat-error>
      <mat-error
      *ngIf="frmGroup.get(configData.name).errors.customValidation">
      {{frmGroup.get(configData.name).errors.customValidation.message}}
    </mat-error>
    </mat-error>
</mat-form-field>
